import script from "./Technology.vue?vue&type=script&setup=true&lang=js"
export * from "./Technology.vue?vue&type=script&setup=true&lang=js"

import "./Technology.vue?vue&type=style&index=0&id=6abd05b7&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6abd05b7"]])

export default __exports__